import Hero from "../components/hero";
import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import usePageBackground from "../hooks/usePageBackground";
import { Box, Typography, Container } from '@mui/material';
import '../css/global.css';
import '../css/calendar-home.css';
import Calendar from "./calendar";
import FadeItem from "../components/fadeItem";
import { useFadeInOnScroll } from "../theme/global";
import hero from '../assets/images/logos/logo_final_sim_fondo.svg'
import Loader from '../components/loader';

const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.5 } },
  };
  

  const Home = ({ showHero = true }) => {
    const [loading, setLoading] = useState(true);
    const text1 = [
      "Un espacio para la paz en un mundo con prisa.",
      "Un lugar para cuidarte desde el interior donde eres protagonista.",
      "CES nace con la misión de crear un mundo mejor haciendo que las personas alcancen su bienestar, mostrando una visión integral de la salud donde no existen tabúes a la hora de hablar de la mente, el alma y el cuerpo. Donde la familia, sea del tipo que sea, los amigos, los vecinos, los compañeros, se conviertan en una parte intrínseca de nosotros mismos. Donde el altruismo y la gratitud estén presentes. Un lugar donde la naturaleza tenga cabida, y donde no pongamos límites a la exploración de nuevas perspectivas.",
      "Tenemos la visión de convertirnos en un punto de encuentro para todas aquellas personas que quieren con sus actos lograr un mundo mejor, empezando estos actos por uno mismo.",
      "Nuestros valores son la gratitud, el altruismo, la compasión, la aceptación y el compromiso.",

    ];
  
    const text2 =[
      "Personas felices, familias felices, entornos felices, mundo feliz.",
    "El altruismo es la forma más sencilla de hacer feliz y ser feliz.",
    "La gratitud es inherente al hecho de estar vivo.",
    "El dolor es una realidad, el sufrimiento una opción.",
     "Pedir y buscar ayuda es de valientes.",
     "Prestar y recibir ayuda es de valientes.",
     "El cambio puede lograrse con pequeños actos.",
     "Un mundo mejor es posible.",
  ];
      usePageBackground('home-background-color');
      useEffect(() => { setLoading(false); }, []);
      const calendarRef = useFadeInOnScroll([loading]);
      const imagenRef = useFadeInOnScroll([loading]);

      return (
        <>
          <Helmet>
            <title>Inicio | CES</title>
            <meta name="description" content="Centro de bienestar integral." />
          </Helmet>
          {showHero && <Hero />}

          {loading ? (
            <Loader />
          ) : (
          /* <Container className="home-container" maxWidth="md" sx={{ textAlign: "center", mt: 4 }}> */
          <Box
              p={{ xs: 2, sm: 4, md: 8 }}
              className="home-container"
              sx={{
                textAlign: "center",
                my: 4,
                minHeight: "100vh", // Asegura que al menos ocupe la pantalla completa
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // Centra el contenido verticalmente
                alignItems: "center",
                gap: 1,
                overflow: 'hidden',
                width: "100%",

              }}
            >
          {/* Título */}
          <Typography
            variant="h2"
            paddingTop={2}
            sx={{
              fontFamily: "Great Vibes, cursive",
              fontWeight: 400,
              color: "var(--color-light-beige)",
              mb: 4,
              fontSize: { xs: '2.5rem', sm: '3rem', md: '4rem' },

            }}
          >
            Calma tu mente, Escucha tu alma, Sana tu cuerpo
          </Typography>
  
          {/* Textos con efecto al hacer scroll */}
 

          {text1.map((text, index) => (
            <FadeItem
              key={index}
              text={text}
              style={{
                fontFamily: "Raleway, sans-serif",
                fontWeight: 400,
                fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem' },
                color: "var(--color-light-beige)",
                mb: 2,
              }}
            />
          ))}
       
          {/* <Box ref={imagenRef} width={'100%'} className="fade-up" src={hero} sx={{margin: '2rem'}}>
           <img src={hero} width={'100%'}></img> 
          </Box> */}
          <Box>
          <Box ref={imagenRef} className="fade-up" component="img" src={hero} alt="hero" sx={{
                flex: 1, // Esto hace que el box de la imagen ocupe el mismo tamaño que el texto
                width: { xs: '100%', md: '40rem' },
                margin: '1rem',
                maxWidth: '500px',
                maxHeight: "550px", // Ajusta el tamaño máximo en pantallas grandes
                // borderRadius: "8px",
                // boxShadow: 3,
                objectFit: "cover", // Asegura que la imagen no se distorsione
                height: "auto" // Mantiene la proporción de la imagen
                }} />
          </Box>

            {/* Textos con efecto al hacer scroll */}
 
          {text2.map((text, index) => (
            <FadeItem
              key={index}
              text={text}
              style={{
                fontFamily: "Raleway, sans-serif",
                fontWeight: 400,
                fontSize: { xs: '1rem', sm: '1.25rem', md: '1.25rem' },
                lineHeight: 1.5,
                color: "var(--color-light-beige)",
                mb: 2,
              }}
            />
          ))}

        <Box ref={calendarRef} className="home-calendar" sx={{ display: 'flex', justifyContent: 'center', width: '100%', flexDirection:'column',
          // minHeight:'20rem'
         }}>
        <Typography
            variant="h2"
            paddingTop={2}
            sx={{
              fontFamily: "Great Vibes, cursive",
              fontWeight: 400,
              color: "var(--color-light-beige)",
              mb: 4,
              mt: 3,
              // fontSize: { xs: '2rem', sm: '1.5rem', md: '2rem' },

            }}
          >
            Calendario de actividades
          </Typography>

          <Calendar showActivities variant="home" />
        </Box>

          

        </Box>
          )}
          {/* </Container> */}
        </>
      );
  };
  
  export default Home;

